module.exports = __webpack_public_path__ + "static/img/upbackground.3e91aa56.png";